module.exports = __webpack_public_path__ + "img/beefapp_en_code.dbdc8f29.png";